// extracted by mini-css-extract-plugin
export default {"section":"wq-z","sectionTitle":"xq-z","fieldWrapper":"yq-z","formField":"zq-z","disabled":"Aq-z","formLabel":"Bq-z"};